module.exports = __webpack_public_path__ + "static/media/dobletick.d219467f.svg";